/**
 * author: Ananthapadmanabhan V K
 */
import { Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";

const ConfirmDialog = (props) => {
    const { title, children, open, setOpen, onConfirm } = props;
    return (
        <Modal show={open}
            onHide={() => setOpen(false)}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            {/* {
                title && (
                    <Modal.Header closeButton>
                        <Modal.Title as="h5">{title}</Modal.Title>
                    </Modal.Header>
                )
            } */}
            <Modal.Body>
                <div className="d-flex align-items-center justify-content-center"
                    style={{ height: '100px' }}>
                    {children}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="px-3" onClick={() => setOpen(false)}>
                    {props.t("Cancel.label")}
                </Button>
                <Button variant="primary" className="px-3" onClick={() => {
                    setOpen(false);
                    onConfirm();
                }}>
                    {props.t("Confirm.label")}
                </Button>

            </Modal.Footer>
        </Modal >
    );
};
export default withTranslation()(ConfirmDialog);